import { render } from "./TermsAlert.vue?vue&type=template&id=2a0e3ba2"
import script from "./TermsAlert.vue?vue&type=script&lang=js"
export * from "./TermsAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__